import { Component, OnInit, Input, NgZone } from '@angular/core'
import { DataPageOfProblem, Problem, UiPreferences } from '../../../../api/models'
import { UntypedFormBuilder } from '@angular/forms'
import { Router, ActivatedRoute } from '@angular/router'
import { MessageService, SortEvent } from 'primeng/api'
import {
  AllergyService,
  AppSettingService,
  ColumnChooserService,
  ProblemService,
} from '../../../../api/services'
import { DatePipe } from '@angular/common'
import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from '../../../directives/customsort'
import { CareFinitySession } from '../../../services/CareFinitySession'

@Component({
  selector: 'app-problem-list',
  templateUrl: './problem-list.component.html',
  styleUrls: ['./problem-list.component.css'],
})
export class ProblemListComponent implements OnInit {
  Item = 'Problems'
  problem: DataPageOfProblem
  selectedPatient: Problem
  Lastpageindex: number = 1
  rows: number
  _selectedColumns: any[]
  showRecords: boolean = false

  public cols: any[]
  othercol: any[]
  pageNumber: number = 1
  sortby: string = 'Desc' //Asc
  txtSearch: string = ''

  patientFullName
  showPatientDemographicPrint: boolean = false

  recognition: any
  searchQuery: string = ''
  isListening: boolean = false // Track if speech recognition is active
  isSearchByVoice: boolean = true
    pageSize: number = 0;
    preferences: UiPreferences = {};

    setPrintFlag: boolean =false;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private messageService: MessageService,
    private problemservice: ProblemService,
    private columnchooserservice: ColumnChooserService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private cstsort: Customsort,
    private appSetting: AppSettingService,
    private ngZone: NgZone,
  ) {}

    ngOnInit()
    {
     
        this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;


        localStorage.removeItem('sortOrder');

    this.cols = [
      { field: 'shortVisitDate', header: 'Visit Date' },
      { field: 'onSetDate', header: 'Onset Date' },
      { field: 'diagnosisCodeID', header: 'Code' },
      { field: 'problemDescription', header: 'Condition' },
      { field: 'statusDescription', header: 'Status' },
      { field: 'diagnosedDate', header: 'Diagnosed Date' },
      { field: 'isResolved', header: 'Resolved' },
    ]

    this.patientFullName = sessionStorage.getItem('ptName')

    this.bindPatientProblemList(this.pageNumber, this.sortby)

        this.appSetting
            .appSettingGetPracticeSettings$Response()
            .subscribe((res) => {
                this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
                if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
                    this.setPrintFlag = true;
                }
                else {
                    this.setPrintFlag = false;
                }
            });

       

    const { webkitSpeechRecognition }: any = window as any
    this.recognition = new webkitSpeechRecognition()
    this.recognition.lang = 'en-US' // Set language
    this.recognition.continuous = false // Stop automatically after a phrase is recognized
    this.recognition.interimResults = false;
    this.recognition.onresult = (event: any) => {
        this.ngZone.run(() => {
            this.searchQuery = event.results[0][0].transcript
            this.performSearch(this.searchQuery) // Implement your search logic
        });


    }

    // Set the listening state to false when recognition stops
    this.recognition.onend = () => {
      this.ngZone.run(() => {
        this.isListening = false
      })
    }

       
       

        const storedPreferences = localStorage.getItem('uiPreferences');

        if (storedPreferences) {

            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.problems || 'Problems';

        }
    }

  //startListening(): void {
  //  this.recognition.start()
  //}

  performSearch(query: string): void {
    console.log('Search query:', query)
    // Add your search logic here
    //  this.isListening = true;
    this.txtSearch = query
    this.bindPatientProblemList(this.pageNumber, this.sortby)
  }

  //welComeAlex() {
  //    //this.speakMessage("Welcome to Care Health, Alex!");
  //    //this.speakMessage("What can I help you with? Do you want me to perform a search?");
  //    //this.speakMessage("Please tell me the patient's problem. If needed, I can perform a quick search for you.?");
  //    //this.speakMessage("Press me?");

  //}

  /**
   * This method is used to fetch the list of patient problems :: And also bind  field columns as show in table list.
   * It also bind dynamic columns list.
   * param pageNumber
   * param sortbydirection
   */

  bindPatientProblemList(pageNumber: number, sortbydirection: string) {
    debugger
    this.problemservice
      .problemList({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
        sortbydirection: sortbydirection,
        searchText: this.txtSearch,
      })
      .subscribe(
        (respProblemList) => {
          console.log(respProblemList)
          this.problem = respProblemList

          this.problem.data = respProblemList.data.map((i) => ({
            ...i,
            ...i.otherColumns,
          }))
          this.rows = this.problem.pageSize

          if (this.problem.totalRecords > 0) {
            this.showRecords = true
          } else {
            this.showRecords = false
          }

          //for (var key in this.problem.data[0].otherColumns) {
          //    this.cols.push({ field: key, header: key });
          //}
          let addedFields = new Set(this.cols.map((col) => col.field))

          for (var key in this.problem.data[0].otherColumns) {
            if (this.problem.data[0].otherColumns.hasOwnProperty(key)) {
              // Check if key is already in addedFields set
              if (!addedFields.has(key)) {
                // Add to addedFields set
                addedFields.add(key)

                // Push to this.cols
                this.cols.push({ field: key, header: key })
              }
            }
          }
          if (
            this.problem.data[0].savedColumns != null &&
            this.problem.data[0].savedColumns.length > 0
          ) {
            var Savednames = this.problem.data[0].savedColumns.split(',')
            this._selectedColumns = this.cols.filter((col) =>
              Savednames.includes(col.field),
            )
          } else {
            this._selectedColumns = this.cols
          }
        },
        (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error,
            life: 3000,
          })
        },
      )
  }
  @Input() get selectedColumns(): any[] {
    // console.log(this._selectedColumns);
    return this._selectedColumns
  }

  set selectedColumns(val: any[]) {
    let selectedValues = [...val]

    if (selectedValues.length == 0) {
      selectedValues = this._selectedColumns = [this.cols[0]]
    } else {
      //restore original order

      this._selectedColumns = val
    }

    let filteredData = Array.prototype.map
      .call(selectedValues, (s) => s.field)
      .toString()
    let filteredValue = Array.prototype.map
      .call(selectedValues, (s) => s.header)
      .toString()

    this.columnchooserservice
      .columnChooserColumnchooser({
        columnNames: filteredData,
        columnValue: filteredValue,
        type: 'Problem',
      })
      .subscribe((result) => {})
  }
    customSort(event: SortEvent, num: number)
    {
              
        const savedOrder = localStorage.getItem("sortOrder");
        if (savedOrder !== null) {
            // Toggle between 1 and -1
            event.order = Number(savedOrder) === 1 ? -1 : 1;
        } else {
            // Default to ascending if nothing stored
            event.order = 1;
        }

        localStorage.setItem("sortOrder", event.order.toString());
        this.problem.data = this.cstsort.generalcustomSort(event, this.problem.data);


    }

  searchProblems() {
    if (this.txtSearch.length > 1) {
      this.problem = null
      this.rows = null
      this.bindPatientProblemList(this.pageNumber, this.sortby)
    }
  }

  clearSearch() {
    if (this.txtSearch.length > 0) {
      this.txtSearch = ''
      this.problem.data = null
      this.bindPatientProblemList(this.pageNumber, this.sortby)
    }
  }

  printProblems() {
    var PrintProblem = document.getElementById(
      'PrintProblem_List',
    ) as HTMLElement
    const printWindow = window.open('', '_blank')
    if (printWindow) {
      const divContent = PrintProblem.innerHTML
      printWindow.document.open()
      printWindow.document.write(
        '<html><head><title>Print::Problem List</title>',
      )
      // Adding CSS styling for alternate rows
      printWindow.document.write('<style type="text/css">')
      printWindow.document.write(
        '    #problem_print_table_tbody tbody tr:nth-child(odd) {',
      )
      printWindow.document.write('        background-color: #f2f2f2;')
      printWindow.document.write('    }')
      printWindow.document.write(
        '    #problem_print_table_tbody tbody tr:nth-child(even) {',
      )
      printWindow.document.write('        background-color: #e6e6e6;')
      printWindow.document.write('    }')
      printWindow.document.write('</style>')
      printWindow.document.write('</head><body>')
      printWindow.document.write(divContent)
      printWindow.document.write('</body><html>')
      printWindow.document.close()
      printWindow.focus()
      printWindow.print()
      printWindow.close()
    } else {
      console.error('Failed to open print window.')
    }
  }

  speakMessage(text: string) {
    // alert(text);
    const utterance = new SpeechSynthesisUtterance(text)

    window.speechSynthesis.speak(utterance)
  }
}
